import cn from 'classnames'
import { BREAKPOINTS, useMediaQuery } from '@mc/media'

type Breakpoint = 'sm' | 'lg' | 'xl'

type MediaComponent = {
  bp: Breakpoint
  className?: string
  children: React.ReactNode
}

const getBpWidth = (bp: Breakpoint) => {
  switch (bp) {
    case 'sm':
      return BREAKPOINTS.SM
    case 'lg':
      return BREAKPOINTS.LG
    case 'xl':
      return BREAKPOINTS.XL
    default:
      return bp // type: never
  }
}

export const LessThan = ({ bp, children, className = '' }: MediaComponent) => {
  const mq = useMediaQuery(`(max-width: ${getBpWidth(bp)}px)`)
  return (
    <div className={cn('d-block', `d-${bp}-none`, className)}>
      {mq ? children : null}
    </div>
  )
}

export const GreaterThanOrEqual = ({
  bp,
  children,
  className,
}: MediaComponent) => {
  const mq = useMediaQuery(`(min-width: ${getBpWidth(bp)}px)`)
  return (
    <div className={cn('d-none', `d-${bp}-block`, className)}>
      {mq ? children : null}
    </div>
  )
}
